import actions from "@/store/modules/menu-table/actions";
import mutations from "@/store/modules/menu-table/mutations";
import state from "@/store/modules/menu-table/state";

export default {
    actions,
    mutations,
    state
}